import { TableSortingOrder } from "@/components/AppTable/ITable"
import { BlockNotification } from "@/modules/applications/blockNotifications/types/notificationTypes"
import { DataUrlSubPath } from "@/modules/provide/digital-twin-browser/types/shellTypes"

export enum EnumEcuPageNames {
  ECU_SENT = "ecu_sent_message_history",
  ECU_RECEIVED = "ecu_received_message_history",
  ECU_ASSETS = "ecu_assets",
  ECU_PROCESS_LOGS = "ecu_process_logs",
  ECU_CONNECTORS = "ecu_connectors",
  ECU_POLICIES = "ecu_policies"
}

export interface CountryStatistic {
  name: string
  receivedCount: number
  sentCount: number
  total: number
}

export interface StatisticsState {
  totalNotifications: number
  sentNotifications: number
  receivedNotifications: number
  topCountries: CountryStatistic[]
  isLoading: boolean
}

export interface EcuNotificationsState {
  notifications: BlockNotification[]
  selectedNotification: BlockNotification | null
  page: number
  size: number
  total: number
  totalPages: number
  dataUrlSubPath: DataUrlSubPath | null
  isLoading: boolean
  sorting: {
    field: string
    type: TableSortingOrder
  }
}

export type EcuNotificationsFilterKey =
  | "conversationName"
  | "bpn"
  | "catenaXId"
  | "ecuId"
  | "catenaXSiteId"
  | "minCreatedAt"
  | "maxCreatedAt"

export interface ConnectorItem {
  id: string
  name: string
  [key: string]: any
}

export interface PolicyItem {
  id: string
  name: string
}
